<template>
  <div class="toast-with-link">
    <span>{{ productName }} aggiunto alla lista! </span>
    <a :href="anchorLink" class="toast-link">Vai alla lista</a>
  </div>
</template>

<script setup>
defineProps({
  productName: String, // nome del prodotto
  anchorLink: {
    type: String,
    default: "#vue-widget", // ancora di default
  },
});
</script>

<style scoped>
.toast-link {
  color: #fff;
  text-decoration: underline;
  margin-left: 6px;
}
</style>
